__turbopack_context__.v({
  "body": "home-addons-module__w2ovuq__body",
  "bodyLead": "home-addons-module__w2ovuq__bodyLead",
  "bodyRest": "home-addons-module__w2ovuq__bodyRest",
  "brandLtr": "home-addons-module__w2ovuq__brandLtr",
  "callout": "home-addons-module__w2ovuq__callout",
  "calloutLeft": "home-addons-module__w2ovuq__calloutLeft",
  "calloutRight": "home-addons-module__w2ovuq__calloutRight",
  "callouts": "home-addons-module__w2ovuq__callouts",
  "card": "home-addons-module__w2ovuq__card",
  "dashBack": "home-addons-module__w2ovuq__dashBack",
  "dashBackDark": "home-addons-module__w2ovuq__dashBackDark",
  "dashBackLight": "home-addons-module__w2ovuq__dashBackLight",
  "dashFront": "home-addons-module__w2ovuq__dashFront",
  "dashFrontDark": "home-addons-module__w2ovuq__dashFrontDark",
  "dashFrontLight": "home-addons-module__w2ovuq__dashFrontLight",
  "dashStack": "home-addons-module__w2ovuq__dashStack",
  "eyebrow": "home-addons-module__w2ovuq__eyebrow",
  "glowBack": "home-addons-module__w2ovuq__glowBack",
  "glowFront": "home-addons-module__w2ovuq__glowFront",
  "leaderLeft": "home-addons-module__w2ovuq__leaderLeft",
  "leaderLeftWrap": "home-addons-module__w2ovuq__leaderLeftWrap",
  "leaderRight": "home-addons-module__w2ovuq__leaderRight",
  "leaderRightWrap": "home-addons-module__w2ovuq__leaderRightWrap",
  "mockupBoard": "home-addons-module__w2ovuq__mockupBoard",
  "pillLg": "home-addons-module__w2ovuq__pillLg",
  "plusBarHLg": "home-addons-module__w2ovuq__plusBarHLg",
  "plusBarVLg": "home-addons-module__w2ovuq__plusBarVLg",
  "plusLg": "home-addons-module__w2ovuq__plusLg",
  "plusSm": "home-addons-module__w2ovuq__plusSm",
  "scene": "home-addons-module__w2ovuq__scene",
  "section": "home-addons-module__w2ovuq__section",
  "sticky": "home-addons-module__w2ovuq__sticky",
  "title": "home-addons-module__w2ovuq__title",
  "titleLine": "home-addons-module__w2ovuq__titleLine",
  "top": "home-addons-module__w2ovuq__top",
  "visual": "home-addons-module__w2ovuq__visual",
});
